module.exports = __webpack_public_path__ + "img/f552634.webp";